import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Eye } from "@air/next-icons";
import { formatDateVerbose } from "@air/utilities";
import { clearThumbnailCache } from "@air/utils-clips";
import classNames from "classnames";
import isUndefined from "lodash/isUndefined";
import { memo } from "react";
import { useSelector } from "react-redux";
import { QueryParamNames } from "~/constants/search";
import { VERSION_SNIPPET } from "~/constants/testIDs";
import { centralizedClipIdSelector, centralizedClipOpenDiscussionCountSelector } from "~/store/centralizedClip/selectors";
import { useSwitchVersion } from "~/swr-hooks/versions/useSwitchVersion";
import { VersionListItemThumbnail } from "./VersionListItemThumbnail/VersionListItemThumbnail";
export const VersionListItem = /*#__PURE__*/ memo((param)=>{
    let { version, menu, permissions } = param;
    const clipId = useSelector(centralizedClipIdSelector);
    const openDiscussionCount = useSelector(centralizedClipOpenDiscussionCountSelector);
    const { switchVersion } = useSwitchVersion();
    const isActive = clipId === version.id;
    const onClick = (e)=>{
        e.preventDefault();
        switchVersion({
            version: {
                ...version,
                openDiscussionCount
            },
            location: "tab",
            query: {
                [QueryParamNames.timestamp]: null,
                [QueryParamNames.discussionId]: null
            }
        });
    };
    /**
   * We don't want to render the versions unless their permissions have been fetched
   * because if a user clicks on one too fast (more likely Cypress), the UI of the asset modal
   * will bounce all over the place because the permissons wont' be defined
   */ if (!permissions) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("group/version-list-item version-list-item transition-background relative box-border flex h-full max-h-[116px] w-[120px] cursor-pointer flex-col items-start justify-start rounded bg-transparent p-1 duration-150 ease-in-out hover:bg-grey-5", isActive ? "[&>.asset-modal-version-thumbnail]:shadow-[0px_0px_0px_2px] [&>.asset-modal-version-thumbnail]:shadow-blue-9" : ""),
        onClick: onClick,
        "data-testid": "".concat(VERSION_SNIPPET, "-").concat(version.version),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "opacity-0 group-hover/version-list-item:opacity-100",
                children: menu
            }),
            /*#__PURE__*/ _jsx(VersionListItemThumbnail, {
                isCurrentVersion: version.isDefault,
                src: clearThumbnailCache({
                    clipExt: version.ext,
                    clipStatus: version.status,
                    imageSrc: version.assets.image,
                    clipUpdatedAt: version.updatedAt
                }),
                status: version.status,
                ext: version.ext,
                type: version.type
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "absolute right-3 top-[52px] flex items-center justify-center rounded-sm bg-black/80 px-1 py-0.5",
                children: [
                    isActive && /*#__PURE__*/ _jsx(Eye, {
                        className: "mr-0.5 size-3 text-white"
                    }),
                    !isUndefined(version.version) && /*#__PURE__*/ _jsx("div", {
                        className: "text-10 font-bold uppercase text-grey-12",
                        children: "V".concat(version.version)
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-1.5 w-full truncate text-12 font-medium text-grey-12",
                children: version.title || version.importedName || ""
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex w-full gap-1 truncate text-12 text-grey-10",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "uppercase",
                        children: version.ext
                    }),
                    "\xb7",
                    /*#__PURE__*/ _jsx("span", {
                        children: formatDateVerbose(version.createdAt)
                    })
                ]
            })
        ]
    });
});
VersionListItem.displayName = "VersionListItem";
